import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Menu from "./components/Menu/Menu";
import Landing from "./components/Landing/Landing";
import styles from "./App.module.scss";
import "./App.css";
import DanceStyleDetail from "./components/DanceStyleDetail/DanceStyleDetail";
import OfferDetail from "./components/OfferDetail/OfferDetail";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import News from "./components/News/News";
import Contact from "./components/Contact/Contact";
import NotFound from "./components/NotFound/NotFound"; // Importujemo NotFound komponentu

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <BrowserRouter>
      <Menu isOpen={isMenuOpen} toggleMenu={() => setIsMenuOpen(!isMenuOpen)} />
      <ScrollToTop />

      {/* Ceo sadržaj sajta pomeramo ulevo kada je meni otvoren */}
      <div className={`${styles.container} ${isMenuOpen ? styles.shifted : ""}`}>
        <Routes>
          <Route path="/" element={<><Navbar isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
            <Landing /></>} />
          <Route path="/style/:styleId" element={<DanceStyleDetail />} />
          <Route path="/offer/:offerId" element={<OfferDetail />} />
          <Route path="/news" element={<><Navbar isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
            <News /></>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} /> {/* 404 stranica */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;